import {
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CapabilitiesService } from './capabilities.service';
import { CapabilityName } from './registry-ot.generated';

/**
 * Structural directive that shows its template only when the current user has the
 * named capability. Mirrors the create/clear-view shape of the existing
 * `*otIfRole` (`libs/core/.../if-role.directive.ts`) — but keyed on a capability
 * name instead of a raw role flag, so swaps from `*ngxPermissionsOnly` / `*otIfRole`
 * are mechanical.
 *
 *   <button *otCapability="'canApproveDeal'">Approve</button>
 */
@Directive({
  selector: '[otCapability]',
})
export class CapabilityDirective implements OnDestroy {
  private subscription$: Subscription | null = null;
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private capabilities: CapabilitiesService
  ) {}

  @Input()
  set otCapability(name: CapabilityName) {
    if (this.subscription$) {
      this.subscription$.unsubscribe();
      this.subscription$ = null;
    }
    this.subscription$ = this.capabilities.check$(name).subscribe((allowed) => {
      if (allowed && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!allowed && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription$) {
      this.subscription$.unsubscribe();
    }
  }
}
